import { Link } from 'react-router-dom';
import React from 'react';
import { Card } from 'react-bootstrap';
import { ChevronRight } from 'lucide-react';
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const CardsOrganizational = ({
  metricsDateRangeData,
  totalCount,
  CardLabel,
  iconName,
  AnalyticsIcon,
  countsClassName,
  CardColor,
  details,
  PageRoute,
  isMetricsCard = false,
  metricsCardType = '',
  onMetricsCardClick,
  onDetailsClick,
  isLoading = false
}) => {
  const countClass = countsClassName ? `fw-700 ${countsClassName}` : 'text-32 fw-700 text-accent';
  const cardBg = CardColor ? CardColor : 'bg-soft-amber';

  // For metrics cards, use the new design
  if (isMetricsCard) {
    const getMetricsCardClass = () => {
      switch (metricsCardType) {
        case 'green':
          return 'metrics-card green';
        case 'amber':
          return 'metrics-card amber';
        case 'red':
          return 'metrics-card red';
        default:
          return 'metrics-card';
      }
    };

    const getIconPath = () => {
      switch (metricsCardType) {
        case 'green':
          return '/assets/icons/greenlevel.svg';
        case 'amber':
          return '/assets/icons/amberlevel.svg';
        case 'red':
          return '/assets/icons/redlevel.svg';
        default:
          return '/assets/icons/metrics.svg';
      }
    };

    if (isLoading) {
      return (
        <div className={getMetricsCardClass()}>
          <div className="metrics-card-header">
            <div className="metrics-card-content">
              <Skeleton width={24} height={24} borderRadius={4} />
              <div className="metrics-card-title">
                <Skeleton width={80} height={16} />
              </div>
            </div>
            <div className="metrics-card-number">
              <div className="metrics-card-count">
                <Skeleton width={32} height={24} />
              </div>
            </div>
          </div>
          <div className="metrics-card-details-btn" style={{ cursor: 'default' }}>
            <Skeleton width={60} height={16} />
          </div>
        </div>
      );
    }

    console.log("totalCount"+totalCount);
    return (
      <div className={getMetricsCardClass()}>
        <div className="metrics-card-header">
          <div className="metrics-card-content">
            <img src={getIconPath()} alt={CardLabel} className="metrics-card-icon" />
            <div className="metrics-card-title">{CardLabel}</div>
          </div>
          <div className="metrics-card-number">
            <div className="metrics-card-count">{totalCount?totalCount.toString().padStart(2, '0'):0}</div>
          </div>
        </div>
        <button
          className="metrics-card-details-btn"
          onClick={() => {
            // For risk level cards (green, amber, red), use the new modal
            if (metricsCardType && ['green', 'amber', 'red'].includes(metricsCardType) && onDetailsClick) {
              onDetailsClick(metricsCardType);
            } else if (onMetricsCardClick) {
              // For metrics considered card, use the existing modal
              onMetricsCardClick();
            }
          }}
        >
          <span>Details</span>
          <div className="metrics-card-arrow">
            <ChevronRight size={16} />
          </div>
        </button>
      </div>
    );
  }

  // Original design for non-metrics cards
  return (
    <Card className={`border rounded-20 border-neutral ${cardBg}`}>
      <Card.Body className="p-20">
        <div className="d-flex flex-column gap-16px w-100">
          <div className="d-flex align-items-center">
            {CardLabel ? (
              <>
                {iconName && <span className={`mask-icon w-h-16 me-2 mask-${iconName}`} aria-hidden="true"></span>}
                <span className="text-20 fw-700 text-navy text-nowrap">{CardLabel}</span>
              </>
            ) : (
              AnalyticsIcon && <span className="me-2"><img src={`/assets/${AnalyticsIcon}.png`} alt={AnalyticsIcon} className="w-h-22" /></span>
            )}
          </div>
          <div className={`${countClass} text-accent`}>{totalCount}</div>
        </div>
        {details && details.length > 0 && (
          <div className="mt-3">
            {details.map((detail, idx) => (
              <div key={`${detail.label}-${idx}`} className="d-flex justify-content-between align-items-center mb-9">
                <span className="text-10 fw-500 text-4E4E4E">{detail.label}</span>
                <span className="text-10 fw-600">{detail.value}</span>
              </div>
            ))}
          </div>
        )}
        {PageRoute && (
          <Link to={PageRoute} className="stretched-link" aria-label={`View ${CardLabel}`}></Link>
        )}
      </Card.Body>
    </Card>
  );
};

export default CardsOrganizational;
